var DependentsListDataTestIdEnum = /* @__PURE__ */ ((DependentsListDataTestIdEnum2) => {
  DependentsListDataTestIdEnum2["DEPENDENTS_LIST_ADD_DEPENDENT_BUTTON"] = "dependents-list-add-dependent-button";
  DependentsListDataTestIdEnum2["DEPENDENTS_DISCARD_CHANGES_MODAL"] = "dependents-discard-changes-modal";
  DependentsListDataTestIdEnum2["DEPENDENTS_DISCARD_CHANGES_MODAL_TITLE"] = "dependents-discard-changes-modal-title";
  DependentsListDataTestIdEnum2["DEPENDENTS_DISCARD_CHANGES_MODAL_SAVE_BUTTON"] = "dependents-discard-changes-modal-save-button";
  DependentsListDataTestIdEnum2["DEPENDENTS_DISCARD_CHANGES_MODAL_DISCARD_BUTTON"] = "dependents-discard-changes-modal-discard-button";
  DependentsListDataTestIdEnum2["DEPENDENT_CARD"] = "dependent-card";
  DependentsListDataTestIdEnum2["DEPENDENT_CARD_NAME"] = "dependent-card--name";
  DependentsListDataTestIdEnum2["DEPENDENT_CARD_DOCUMENT"] = "dependent-card--document";
  DependentsListDataTestIdEnum2["DEPENDENT_CARD_EDIT_BUTTON"] = "dependent-card--edit-button";
  DependentsListDataTestIdEnum2["DEPENDENT_CARD_DELETE_BUTTON"] = "dependent-card--delete-button";
  return DependentsListDataTestIdEnum2;
})(DependentsListDataTestIdEnum || {});
export {
  DependentsListDataTestIdEnum
};
